import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import HomePageStyle from "./home-page.module.scss"

const HeroBgImg = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulFsdHompage{
        nodes{
          homepageReference{
            hero{
              mobileHeroBgImage{
                fluid(maxWidth: 1000) {
                  ...GatsbyContentfulFluid
                }
              }
            }
          }
        }
      }
    }
  `)

  return <Img alt="Website Design and Development Agency - First String Digital" className={HomePageStyle.heroBgImg} fluid={data.allContentfulFsdHompage.nodes[0].homepageReference.hero.mobileHeroBgImage.fluid} />
}

export default HeroBgImg


